const middleware = {}

middleware['biura/routeAuth'] = require('../middleware/biura/routeAuth.ts')
middleware['biura/routeAuth'] = middleware['biura/routeAuth'].default || middleware['biura/routeAuth']

middleware['blog/routeAuth'] = require('../middleware/blog/routeAuth.ts')
middleware['blog/routeAuth'] = middleware['blog/routeAuth'].default || middleware['blog/routeAuth']

middleware['filmowy-swiat-rainbow/routeAuth'] = require('../middleware/filmowy-swiat-rainbow/routeAuth.ts')
middleware['filmowy-swiat-rainbow/routeAuth'] = middleware['filmowy-swiat-rainbow/routeAuth'].default || middleware['filmowy-swiat-rainbow/routeAuth']

middleware['getParamsFromUrl'] = require('../middleware/getParamsFromUrl.ts')
middleware['getParamsFromUrl'] = middleware['getParamsFromUrl'].default || middleware['getParamsFromUrl']

middleware['isFromCrawler'] = require('../middleware/isFromCrawler.ts')
middleware['isFromCrawler'] = middleware['isFromCrawler'].default || middleware['isFromCrawler']

middleware['routeAuth'] = require('../middleware/routeAuth.ts')
middleware['routeAuth'] = middleware['routeAuth'].default || middleware['routeAuth']

middleware['section-seo'] = require('../middleware/section-seo.ts')
middleware['section-seo'] = middleware['section-seo'].default || middleware['section-seo']

export default middleware
